// extracted by mini-css-extract-plugin
module.exports = {"root":"src-components-page-upgrade-CompareCardHead-module__root--z07Y5"};